import React, { useEffect } from 'react';
import './AgriBusinessServices.css';
import { Target, Eye, Map, Handshake } from 'lucide-react'; // Assuming lucide-react is installed, if not, remove icons or use FontAwesome

const AgriBusinessServices = () => {
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    return (
        <div className="abs-premium-page">
            {/* Hero Section */}
            <section className="abs-hero">
                <div className="abs-hero-content">
                    <h1 className="abs-hero-title">Business Services</h1>
                    <p className="abs-hero-subtitle">
                        Cultivating a Greener Future with Sustainable and Organic Farming
                    </p>
                </div>
            </section>

            <div className="abs-container">

                {/* Introduction Section */}
                <div className="abs-intro-card">
                    <div className="abs-intro-text">
                        <h2 className="abs-heading">Business Profile</h2>
                        <p className="abs-paragraph">
                            ANT is a leading provider of commercial and organic farming services,
                            committed to revolutionizing the agricultural landscape through innovation,
                            sustainability, and eco-friendly practices.
                        </p>
                        <p className="abs-paragraph">
                            With a deep-rooted passion for the land, we integrate cutting-edge technology
                            with time-honored farming traditions to produce high-quality crops that nourish
                            both people and the planet.
                        </p>
                    </div>
                    <div className="abs-intro-visual">
                        <img
                            src='https://res.cloudinary.com/drevfgyks/image/upload/v1724858572/AMARAVATHI%20NATURO%20TECH%20PVT%20LTD/6909_m58ryi.jpg'
                            alt='Agri Business'
                        />
                    </div>
                </div>

                {/* Mission, Vision, Farms Grid */}
                <div className="abs-grid">
                    <div className="abs-card mission">
                        <h3 className="abs-card-title"><Target size={24} color="#2d6a4f" /> Our Mission</h3>
                        <p className="abs-card-text">
                            To grow and deliver top-quality agricultural products for food supplementary using sustainable, organic, and environmentally responsible farming
                            practices that support healthy living and a thriving ecosystem.
                        </p>
                    </div>

                    <div className="abs-card vision">
                        <h3 className="abs-card-title"><Eye size={24} color="#40916c" /> Our Vision</h3>
                        <p className="abs-card-text">
                            To become a global leader in commercial and organic farming and Elite Food & Health Supplements by driving sustainable agricultural practices and contributing
                            to food security while maintaining a healthy and vibrant environment.
                        </p>
                    </div>

                    <div className="abs-card farms">
                        <h3 className="abs-card-title"><Map size={24} color="#52b788" /> Our Farms</h3>
                        <p className="abs-card-text">
                            We operate several commercial and organic farms spread across
                            diverse regions, each tailored to the unique climate and soil conditions.
                            Visit our farms for a first-hand experience.
                        </p>
                    </div>
                </div>

                {/* Partnership Section */}
                <section className="abs-partnership">
                    <div className="abs-partner-content">
                        <h2 className="abs-partner-title"><Handshake size={32} style={{ marginRight: '10px' }} /> Partnership Opportunities</h2>
                        <p className="abs-partner-text">
                            We welcome collaboration with retailers, distributors, food manufacturers,
                            and eco-conscious businesses looking to source high-quality, sustainable, and organic agricultural products.
                            Partner with us and contribute to a healthier, greener future.
                        </p>
                    </div>
                </section>

                <p className="abs-footer-tag">Emerging Farmers Empowerment</p>
            </div>
        </div>
    );
};

export default AgriBusinessServices;
